export default `
  {
    efficiency {
      account_id
      efficiency
    }
  }
`;